import PageHero from "../../components/PageHero/PageHero";
import aboutHeroImage from "../../assests/images/About-Hero.jpg";
import CompanyStory from "../../components/CompanyStory/CompanyStory";
import MissionVision from "../../components/MissionVision/MissionVision";
import Stats from "../../components/Stats/Stats";
import WhyChooseUs from "../../components/WhyChooseUs/WhyChooseUs";
import CTA from "../../components/CTA/CTA";

function About() {
  return (
    <>
      <PageHero
        badge="About MobileFix UAE"
        title="UAE's Trusted Doorstep Mobile Repair Service"
        description="We bring professional mobile repair services directly to your home, office, or preferred location. Our mission is to make smartphone repairs fast, convenient, and stress-free across the UAE."
        backgroundImage={aboutHeroImage}
      />
      <CompanyStory />
      <MissionVision />
      <Stats />
      <WhyChooseUs />
      <CTA />
    </>
  );
}

export default About;
